export const en = {
    common: {
        aloapp: "aloPay is a convenient, faster and affordable way to make payments, handle customers and generate invoices",
        offer: "The platform offers :",
        easyPayment: "Easy payment",
        processing: "Processing",
        invoiceGe: "Invoice generation",
        receiptsGe: "Receipts generation",
        our: "Our",
        solution: "Solution",
        payout_number: "Momo number (0551611100)",
        enter_account: "Enter account name",
        momo: "Momo number",
        momo_name: "Momo name",
        provider: "Provider name",
        select_provider: "Select provider",
        processPay: "Process payments seamlessly for all invoices. Integrate with secure payment gateways to collect payments directly from clients",
        home: "Set Up Your Payment Integration and Invoice",
        control: "From customer to cash flow: one platform, total control.",
        explore: "Explore Platform",
        why: "Why Choose",
        handle: "Handle your payment, accounts and customers all in one place.",
        digital: "Go digital, easily create, send and track payments in real-time, reducing manual errors and speeding up payment cycles.",
        easy: "Easy Payment Processing",
        process: "Process payments seamlessly for all invoices.",
        integrate: "Integrate with secure payment gateways to collect payments directly from clients.",
        secure: "Secure",
        local: "Local-currency",
        instant: "instant transfer",
        real: "Real-Time Analytics",
        provide: "Provides you with a financial overview and detailed analytics of your total invoices, amount earned and history.",
        analytics: "analytics",
        insights: "insights",
        time: "real-time",
        safe: "Safe and Secure",
        keep: "Keep your invoices and clients information secure with our trusted platform. Access your data anytime, anywhere.",
        cloud: "cloud-based",
        encrypt: "encrypted",
        login: "Login / SignUp",
        welcome: "Welcome !",
        log: "Login or create an account to get started.",
        success: "success!",
        successful: "Login Successful!",
        sign: "Sign in with your credentials",
        forgot: "Forgot password?",
        create: "Create new account",
        signin: " Sign in",
        register: "Register Successful !",
        registration: "Registration failed—please try again!",
        error: "Error",
        name: "Name",
        email: "Email",
        company: "Company Name",
        phone: "Phone",
        password: "Password",
        upload: "Upload Logo",
        account: "create account",
        loggin: "Login",
        wrong: "Wrong email or password!",
        language: "Language",
        reset: "Reset Password!",
        request: "Request Password Reset",
        match: "Passwords do not match.",
        reset_success: "Password has been reset successfully.",
        reset_fail: "Failed to reset password.",
        enter: "Enter your new password",
        password_sent: "Password reset link sent to your email.",
        password_failed: "Failed to send password reset link.",
        enter_mail: "Enter your email",
        request_reset: " Request Reset",
        terms: "Terms and Condiitons",
        privacy: "Privacy Policy",
        commission: "Commissions",
        alovroom: "Alovroom revenue"
    },

    sidenav: {
        dash: "Dashboard",
        profile: "Profile",
        add_user: "Add User",
        category: "Categories",
        add_category: "Add Category",
        product: "Products",
        add_product: "Add Product",
        customer: "Customers",
        add_customer: "Add Customer",
        invoice: "Invoices",
        add_invoice: "Add Invoice",
        accounts: "Accounts",
        wallet: "Wallet"
    },

    dashboard: {
        invoice: " Invoice Completed",
        details: "see details",
        users: "Users",
        customers: "Customers",
        products: "Products",
        dash: "Dashboard",
        profile: "My profile",
        logout: "Logout"

    },

    profile: {
        management: "Profile Management",
        adduser: "Add User",
        profile: "Profile",
        phone: "Phone",
        name: "Name",
        edituser: "Edit user",
        deleteuser: "Delete user",
        success: "success!",
        userupdated: "User Updated",
        failed: "User update failed",
        submit: "Submit",
        cancel: "Cancel",
        sure: "Are you sure?",
        error: "Error",
        successful: "User creation Succcefull!",
        not_successful: "User creation failed—please try again!",
        delete_text: "You won't be able to revert this!",
        delete_confirm: "Yes, delete it!",
        delete_success_title: "Deleted!",
        delete_success_message: "Your user has been deleted.",
        delete_error_title: "An unexpected error occurred. Please try again."


    },

    category: {
        delete_text: "You won't be able to revert this!",
        delete_confirm: "Yes, delete it!",
        sure: "Are you sure?",
        not_successful: "Failed to delete category. Please try again.",
        delete_error_title: "An unexpected error occurred. Please try again.",
        management: "Categories Management",
        add_category: "Add Category",
        cat: "Category",
        edit_category: "Edit category",
        delete_category: "Delete category",
        updated: "Category Updated",
        failed: "Category Update failed",
        search: "Search categories",
        edit_category_details: "Edit category details",
        successful: " Categories creation Successful!",
        not_successfull: " Categories creation failed—please try again!",
        remove: "Remove",
        add_another: "Add Another Category",
        category_name: "Category name"

    },

    product: {
        not_successful: "Failed to delete product. Please try again.",
        // delete: "Deleted!",
        deleted: "Your product has been deleted.",
        management: "Products Management",
        products: "Products",
        add_products: "Add products",
        search: "Search products...",
        product_name: "Product name",
        quantity: "Quantity",
        price: "Price",
        delete: "Delete Product",
        edit: "Edit Product",
        edit_details: "Edit Product Details",
        product_updated: "Product Updated",
        failed: " Product updation failed",
        details: "Details",
        seterror: "The category is required for each product and the quantity must be non-negative.",
        select: "Select a category",
        add_another: "Add Another Product",
        successful: "Product creation Successful!",
        not_successfull: "Product creation failed—please try again!"
    },

    customer: {
        not_successful: "Failed to delete customer. Please try again.",
        deleted: "Your customer has been deleted.",
        customers: "Customers",
        management: "Customer Management",
        add_customer: "Add Customer",
        address: "Address",
        country: "Country",
        edit_customer: "Edit Customer",
        edit_customer_details: "Edit Customer Details",
        updated: "Customer Updated",
        successful: "Customer creation Successful!",
        not_successful: "Customer creation failed—please try again!",
        town: "Town",
        add_another: "Add Another Customer",
        select: "Select a country",
        search: "Search customers..."

    },

    invoice: {
        invoices: "Invoices",
        payment_confrim: "Payment Confirmation",
        proceed: "Proceed by clicking pay now",
        pay_now: "Pay now with PawaPay",
        pay_now_stack: "Pay now",
        proccessed: "Payment will be processed in GHS",
        equivalent: "Equivalent",
        management: "Invoices Management",
        add_invoice: "Add Invoice",
        payment_success: "Payment status updated successfully",
        not_updated: "Payment status not updated",
        search: "Search invoices...",
        searchUser: "Search users...",
        filter: "Filter",
        customer_name: "Customer Name",
        customer_country: "Customer Country",
        customer_address: "Customer Address",
        customer_email: "Customer Email",
        customer_phone: "Customer Phone",
        invoice_date: "Invoice Date",
        customer_product_name: "Product Name",
        quantity: "Quantity",
        price: "Price",
        discount: "Discount",
        subtotal: "Subtotal",
        status: "Status",
        paid: "Paid",
        not_paid: "Not Paid",
        edit_invoice: "Edit invoice",
        edit_invoice_details: "Edit invoice details",
        delete_invoice: "Delete invoice",
        payment_link: "Send payment link",
        send_receipt: "Send receipt",
        print_invoice: "Print invoice",
        updated: "Invoice Updated",
        not_updatedd: "Invoice not updated",
        link_sent: "Payment link sent",
        link_not__sent: "wrong email or link already sent",
        to: "To",
        clear:"Clear",
        submitting: "Submitting...",
        receipt_sent: "Receipt sent",
        receipt_not_sent: "wrong email or email sent already",
        not_successfull: "Failed to delete invoice. Please try again.",
        deleted: "Your invoice has been deleted.",
        select_customer: "Select a customer",
        select_product: "Select a product",
        successfull: "Invoice creation successful!",
        not_successful: "Invoice creation failed—please try again!",
        loading: "Loading invoice...",
        error_invoice: "Error Loading Invoice",
        retry: "Retry",
        not_found: "Invoice Not Found",
        not_be_found: "The requested invoice could not be found.",
        choosing: "Thanks for choosing us,",
        location: "Location:",
        amount: "Amount",
        initiate: "Initiate Payment",
    },


    wallet: {
        balance: "Wallet Balance",
        setup: "Setup Wallet",
        banks: "Select Bank",
        select_bank: "Select a bank",
        account_number: "Account Number",
        veirfy: " Verify",
        account_name: "Account Name",
        setup_wallet: "Set Up Wallet",
        withdrawal: "Withdrawal Request",
        amount: "Amount",
        request: "Request Withdrawal",
        withdrawal_request: "Withdrawal Requests",
        bank: "Bank",
        status: "Status",
        no_withdrawall: "No withdrawal requests found",
        valid: "Please enter a valid account number and select a bank",
        wrong: "Wrong account or bank",
        verified: "Verified",
        verify_account: "Please verify your account number first",
        wallet_setup: "Wallet setup successful!",
        insufficient: "Insufficient balance",
        wallet: "Wallet",
    },

};